import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../../data/mock';

const CTA = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#1a1a1a]" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Content */}
          <div>
            <p className="text-white/40 text-sm tracking-[0.2em] uppercase mb-4">
              Parlons de votre projet
            </p>
            <h2 
              className="text-4xl lg:text-5xl text-white mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Prêt à découvrir<br />
              <span className="italic">Les Terres de Songon ?</span>
            </h2>
            <p className="text-white/60 text-lg leading-relaxed mb-10">
              Notre équipe est à votre disposition pour vous accompagner 
              dans votre projet immobilier. Contactez-nous pour organiser une visite.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <Link to="/contact">
                <button className="bg-white text-[#1a1a1a] px-8 py-4 text-sm font-medium tracking-wide hover:bg-white/90 transition-all duration-300 flex items-center gap-2">
                  Nous contacter
                  <ArrowRight className="w-4 h-4" />
                </button>
              </Link>
            </div>
          </div>

          {/* Right: Contact Info */}
          <div className="lg:pl-16">
            <div className="space-y-8">
              <div>
                <p className="text-white/40 text-xs tracking-[0.2em] uppercase mb-3">Téléphone</p>
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="text-white text-xl flex items-center gap-3 hover:text-white/80 transition-colors"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <Phone className="w-5 h-5" />
                  {contactInfo.phone}
                </a>
              </div>
              <div>
                <p className="text-white/40 text-xs tracking-[0.2em] uppercase mb-3">Email</p>
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="text-white text-xl flex items-center gap-3 hover:text-white/80 transition-colors"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <Mail className="w-5 h-5" />
                  {contactInfo.email}
                </a>
              </div>
              <div className="pt-8 border-t border-white/10">
                <p className="text-white/40 text-sm">
                  Réponse sous 24h
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
